module.exports = __webpack_public_path__ + "img/plant-mobile.43fc46ac.jpg";